import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.jsx';
import {
  Hidden
} from '@material-ui/core';
import { withRouter } from "react-router";
import ReactGA from 'react-ga';
import {contentData} from './content.jsx';

import AboutDesktop from './AboutDesktop/AboutDesktop.jsx';
import AboutMobile from './AboutMobile/AboutMobile.jsx';

class About extends Component{

  componentDidMount(){
    window.scrollTo(0,0)
    ReactGA.initialize('UA-134909612-1');
    ReactGA.pageview(window.location.pathname);
  }

  sendToPage = (event, url) => {
    this.props.history.push(url);
  } 

  render(){

    const {language} = this.props
    const content = contentData[language]

    let desktopView = (
      <Hidden smDown>
        <AboutDesktop content={content} sendToPage={this.sendToPage}/>
      </Hidden>
    )

    let mobileView = (
      <Hidden mdUp>
        <AboutMobile content={content} sendToPage={this.sendToPage}/>
      </Hidden>
    )
    
    return(
      <div>
      {desktopView}
      {mobileView}
    </div>
    )
  }
}

export default withRouter(withStyles(styles)(About));
